import type { ReactNode } from 'react';

export const symbol_subdirectory_arrow_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m275-325 141 141q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9L181-336q-5-5-7-10t-2-11q0-6 2-11t7-10l191-191q9-9 21.5-9t21.5 9q9 9 9 21.5t-9 21.5L274-385h426v-385q0-13 8.5-21.5T730-800q13 0 21.5 8.5T760-770v385q0 25-17.5 42.5T700-325H275Z"
		/>
	</svg>
);
